var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('main-aside');
export var MainAsideDefaultProps = {
  space: 8,
  showAsideHead: true,
  showAsideFoot: true,
  asideRatio: 1 / 3
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n  "], ["\n    display: flex;\n    padding: ", ";\n    flex-direction: column;\n  "])), theme.UNIT(0)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-right: 0;\n    flex-direction: row;\n  "], ["\n    padding-right: 0;\n    flex-direction: row;\n  "])))
});
var MainStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: content-box;\n  "], ["\n    width: 100%;\n    box-sizing: content-box;\n  "]))),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var ratio = _a.ratio;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: ", "%;\n    "], ["\n      width: ", "%;\n    "])), 100 * ratio);
  })
});
var AsideStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: content-box;\n  "], ["\n    width: 100%;\n    box-sizing: content-box;\n  "]))),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 33.33333%;\n    ", "\n  "], ["\n    width: 33.33333%;\n    ", "\n  "])), function (_a) {
    var space = _a.space,
      ratio = _a.ratio;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      width: calc(", "% - ", ");\n      padding-left: ", ";\n    "], ["\n      width: calc(", "% - ", ");\n      padding-left: ", ";\n    "])), 100 * ratio, theme.UNIT(space), theme.UNIT(space));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Main: styled.main.attrs(cls.attr('main'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled.aside.attrs(cls.attr('aside'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles)
};
export var MainAside = function (props) {
  var className = props.className,
    children = props.children,
    main = props.main,
    aside = props.aside,
    space = props.space,
    asideRatio = props.asideRatio,
    asideHead = props.asideHead,
    asideFoot = props.asideFoot,
    showAsideHead = props.showAsideHead,
    showAsideFoot = props.showAsideFoot,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter;
  var hasAside = !!aside;
  var mainRatio = hasAside ? 1 - asideRatio : 1;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Main, {
    hasAside: hasAside,
    ratio: mainRatio
  }, mainHeader, main || children, mainFooter), React.createElement(My.Aside, {
    ratio: asideRatio,
    space: space
  }, showAsideHead && asideHead, aside, showAsideFoot && asideFoot));
};
MainAside.defaultProps = MainAsideDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;